$(document).ready(function () {
  /**
   *  Lazy Load Imagaes
   */

  function loadImages() {
    $('[data-img-bg]').each(function () {
      var el = $(this)
      var src = $(this).data('img-bg')
      if (src) {
        var img = new Image()
        img.style.display = 'none'
        img.src = src
        el.css('background-image', 'url(' + src + ')')
        img.onload = function () {
          el.addClass('loaded')
        }
      }
    })
    $('[data-img-src]').each(function () {
      var el = $(this)
      var src = $(this).data('img-src')
      if (src) {
        var img = new Image()
        img.style.display = 'none'
        img.src = src
        el.attr('src', src)
        img.onload = function () {
          el.addClass('loaded')
        }
      }
    })
  }
  loadImages()
  /**
   *  END - Lazy Load Imagaes
   */
})

$(window).load(function () {
  /**
   * Page Scroll
   */

  window.addEventListener('scroll', () => onPageScroll())
  var currScrollPos = window.scrollY
  var nav = $('#js-nav')

  function onPageScroll() {
    var prevScrollPos = currScrollPos
    currScrollPos = window.scrollY

    if (currScrollPos > 50) {
      // add sticky
      nav.addClass('sticky')

      // detect scroll direction, and show or hide
      if (currScrollPos > prevScrollPos) {
        // going down
        nav.removeClass('sticky-visible')
      } else {
        // going up
        nav.addClass('sticky-visible')
      }

      // remove sticky if scroll is less than 80 and scroll is going down.
    } else {
      if (currScrollPos > prevScrollPos) {
        // scrolling down
        nav.removeClass('sticky')
        nav.removeClass('sticky-visible')
      }

      if (currScrollPos == 0) {
        nav.removeClass('sticky')
        nav.removeClass('sticky-visible')
      }
    }
  }

  /**
   * END Page Scroll
   */

  /**
   * Start Scroll Trigger
   */

  function animateFrom(elem, direction) {
    direction = direction || 1
    var x = 0,
      y = direction * 100
    if (elem.classList.contains('gs_reveal_fromLeft')) {
      x = -100
      y = 0
    } else if (elem.classList.contains('gs_reveal_fromRight')) {
      x = 100
      y = 0
    }
    elem.style.transform = 'translate(' + x + 'px, ' + y + 'px)'
    elem.style.opacity = '0'
    gsap.fromTo(
      elem,
      { x: x, y: y, autoAlpha: 0 },
      {
        duration: 1.25,
        x: 0,
        y: 0,
        autoAlpha: 1,
        ease: 'expo',
        overwrite: 'auto',
      }
    )
  }

  function hide(elem) {
    gsap.set(elem, { autoAlpha: 0 })
  }

  gsap.registerPlugin(ScrollTrigger)

  // Slide-in reveals
  gsap.utils.toArray('.gs_reveal').forEach(function (elem) {
    hide(elem) // assure that the element is hidden when scrolled into view

    ScrollTrigger.create({
      trigger: elem,
      onEnter: function () {
        animateFrom(elem)
      },
      onEnterBack: function () {
        // animateFrom(elem, -1)
      },
      onLeaveBack: function () {
        hide(elem)
      }, // assure that the element is hidden when scrolled into view
    })
  })

  // Parallax
  gsap.utils.toArray('.gs_header_parallax').forEach(function (elem) {
    gsap
      .timeline({
        scrollTrigger: {
          trigger: elem,
          start: 'top top',
          end: 'bottom top',
          scrub: true,
        },
      })
      .to(elem, { yPercent: 20, ease: 'none' }, 0)
  })

  // 3/4 SVG icons animation
  gsap.utils.toArray('.js-three-fourths-svg').forEach(function (elem) {
    ScrollTrigger.create({
      trigger: elem,
      start: 'bottom 90%',
      onEnter: function () {
        elem.setAttribute('class', 'js-three-fourths-svg active')
      },
    })
  })

  // Logo animation
  gsap.utils.toArray('.js-logo-animate').forEach(function (elem) {
    ScrollTrigger.create({
      trigger: elem,
      start: 'bottom 100%',
      onEnter: function () {
        elem.classList.remove('js-logo-animate')
      },
    })
  })

  gsap.utils.toArray('.js-logo-stroke-animate').forEach(function (elem) {
    ScrollTrigger.create({
      trigger: elem,
      start: 'bottom 100%',
      onEnter: function () {
        elem.classList.add('active')
      },
    })
  })

  // Stats animation
  gsap.utils.toArray('.js-animate-stat').forEach(function (elem) {
    const number = $(elem).find('.number')
    const num = $(elem).find('.number').data('num')
    const obj = { number: 0 }

    ScrollTrigger.create({
      trigger: elem,
      start: 'top bottom',
      onEnter: function () {
        gsap.set(elem, { scale: 0 })
        gsap.fromTo(elem, 2, { scaleX: 0, scaleY: 0 }, { scaleX: 1, scaleY: 1 })
        gsap.fromTo(
          obj,
          3,
          { number: 0 },
          {
            number: num,
            onUpdate: () => {
              number.html(Math.round(obj.number))
            },
          }
        )
      },
      onLeaveBack: function () {
        gsap.set(elem, { scale: 0 })
      },
    })
  })

  /**
   * Window Resize
   */
  var resize_window
  $(window).resize(function () {
    clearTimeout(resize_window)
    resize_window = setTimeout(resizeWindow, 200)
  })
  function resizeWindow() {
    var windowWidth = window.innerWidth

    // Larger than small
    if (windowWidth > 768) {
    }
  }
})
